import './sessionpopup.less'

import {SequenceSessionModel} from 'models/program/SequenceSessionModel'
import {SessionModel} from 'models/program/SessionModel'
import React, {useEffect, useState} from 'react'
import useRouter from 'use-react-router'
import {routeToParams, useIsDark, useSearchParams} from 'util/hooks'
import {useTranslation} from 'util/i18n'
import {style} from 'util/style'
import {PopupModal} from 'views/layout/popupmodal'
import {
	SpeakerPopupImage,
	SpeakerPopupSocial
} from 'views/program/popups/speakerpopup'
import {
	ProgramPopupHeader,
	ProgramPopupParent,
	ProgramPopupSpeakers,
	ProgramPopupText,
	PropgramPopupTitle
} from 'views/program/programpopup'

const styles = style('sessionpopup', ['presentations'])

export const SessionPopup: React.FC<{
	session: SessionModel | SequenceSessionModel
}> = ({session}) => {
	const {title, start_time, end_time} = session

	const isDark = useIsDark()
	const router = useRouter()
	const searchParams = useSearchParams()
	const t = useTranslation('popup')

	const setSpeaker = (newSpeaker: string) => {
		routeToParams(router, {...searchParams, speaker: newSpeaker})
	}
	const speaker =
		session.speakers.find(s => s.path === searchParams.speaker) ||
		session.speakers[0]

	return (
		<div className={styles().mod({dark: isDark})}>
			{session instanceof SequenceSessionModel && (
				<ProgramPopupParent
					parent={session.sequence}
					summit={session.sequence.day?.theme}
				/>
			)}
			{speaker && (
				<PopupModal.Content>
					<PopupModal.Left>
						<SpeakerPopupImage {...speaker.data} summits={speaker.summits} />
						<SpeakerPopupSocial {...speaker.data} />
					</PopupModal.Left>
					<PopupModal.Right>
						<ProgramPopupHeader
							title={title}
							start_time={start_time}
							end_time={end_time}
							location={session.room}
						/>
						<ProgramPopupSpeakers
							speakers={session.speakers}
							active={speaker}
							setSpeaker={speaker => setSpeaker(speaker.path)}
						/>
						<ProgramPopupText text={session.description} />
						<PropgramPopupTitle title={t('bio')} />
						<ProgramPopupText text={speaker.biography} />
					</PopupModal.Right>
				</PopupModal.Content>
			)}
			{!speaker && (
				<PopupModal.Content>
					<ProgramPopupHeader
						title={title}
						start_time={start_time}
						end_time={end_time}
						location={session.room}
					/>
					<ProgramPopupText text={session.description} />
				</PopupModal.Content>
			)}
		</div>
	)
}
